import { createAzSavantClients } from "savant-az-connector";
import { FeedbackApi } from "./gen/clients/cfs-api-client";
import {
  AzureResourceApi,
  CloudLinkApi,
  DeploymentApi,
  MultiCloudVirtualNetworkApi,
  NetworkLinkApi,
  RegionsInfoApi,
} from "./gen/clients/mchub-azure-api-client";
import { AdbsAdaptorApi } from "./gen/clients/mchub-azure-api-client-adb";
import { MulticloudDatabaseApi } from "./gen/clients/mchub-azure-api-client-exa";
import { MdsAdaptorApi } from "./gen/clients/mchub-azure-api-client-mds";
import { BillingApi, IncidentApi, LimitsApi } from "./gen/clients/mchub-azure-api-client-platform";
import { VmDatabaseApi } from "./gen/clients/mchub-azure-api-client-vmdb";
import { clientId, feedbackApiUrl, mchubEndpointTemplate } from "./session/sessionConstants";

export const MultiCloudDatabaseApiVersion = undefined;
export const NetworkLinkApiVersion = "20220401";

const cfsScopes = [`api://${clientId}/myscopes openid profile`];
const exaDatabaseScopes = [`api://${clientId}/myscopes openid profile`];
const vmDatabaseScopes = [`api://${clientId}/myscopes openid profile`];
const adbsDatabaseScopes = [`api://${clientId}/myscopes openid profile`];
const mdsDatabaseScopes = [`api://${clientId}/myscopes openid profile`];
const netLinkScopes = [`api://${clientId}/myscopes openid profile`];
const azResourceScopes = [`api://${clientId}/myscopes openid profile`];
const cloudLinkScopes = [`api://${clientId}/myscopes openid profile`];
const deploymentScopes = [`api://${clientId}/myscopes openid profile`];
const incidentsScopes = [`api://${clientId}/myscopes openid profile`];
const limitsScopes = [`api://${clientId}/myscopes openid profile`];
const billingScopes = [`api://${clientId}/myscopes openid profile`];
const regionsScopes = [`api://${clientId}/myscopes openid profile`];
const networkScopes = [`api://${clientId}/myscopes openid profile`];

const [clients, initialize, setActiveRegion, withRegion] = createAzSavantClients({
  cfsApi: {
    class: FeedbackApi,
    template: feedbackApiUrl,
    scopes: cfsScopes,
  },
  exaDatabaseApi: {
    class: MulticloudDatabaseApi,
    template: mchubEndpointTemplate,
    scopes: exaDatabaseScopes,
  },
  vmDatabaseApi: {
    class: VmDatabaseApi,
    template: mchubEndpointTemplate,
    scopes: vmDatabaseScopes,
  },
  adbsDatabaseApi: {
    class: AdbsAdaptorApi,
    template: mchubEndpointTemplate,
    scopes: adbsDatabaseScopes,
  },
  mdsDatabaseApi: {
    class: MdsAdaptorApi,
    template: mchubEndpointTemplate,
    scopes: mdsDatabaseScopes,
  },
  netLinkApi: {
    class: NetworkLinkApi,
    template: mchubEndpointTemplate,
    scopes: netLinkScopes,
  },
  networkApi: {
    class: MultiCloudVirtualNetworkApi,
    template: mchubEndpointTemplate,
    scopes: networkScopes,
  },
  azResourceApi: {
    class: AzureResourceApi,
    template: mchubEndpointTemplate,
    scopes: azResourceScopes,
  },
  cloudLinkApi: {
    class: CloudLinkApi,
    template: mchubEndpointTemplate,
    scopes: cloudLinkScopes,
  },
  deploymentApi: {
    class: DeploymentApi,
    template: mchubEndpointTemplate,
    scopes: deploymentScopes,
  },
  incidentsApi: {
    class: IncidentApi,
    template: mchubEndpointTemplate,
    scopes: incidentsScopes,
  },
  limitsApi: {
    class: LimitsApi,
    template: mchubEndpointTemplate,
    scopes: limitsScopes,
  },
  billingApi: {
    class: BillingApi,
    template: mchubEndpointTemplate,
    scopes: billingScopes,
  },
  regionsApi: {
    class: RegionsInfoApi,
    template: mchubEndpointTemplate,
    scopes: regionsScopes,
  },
});

const apiClients = {
  ...clients,
  initialize,
  setActiveRegion,
  withRegion,
};

export default apiClients;

/**
 *
 * Response interceptor for handling 204 (No Content)
 * Required because savant-generator does not handle multiple
 * success status for the same API call.
 * Logic is limited to handling POST/PUT requests returning 204
 */
export async function noContentResponseInterceptor(
  request: Request,
  response: Response,
): Promise<Response> {
  if (response.status === 204 && (request.method === "POST" || request.method === "PUT")) {
    const body = { code: "No Content" };
    const noContentResponse = new Response(JSON.stringify(body), {
      status: 203,
      statusText: "Non-Authoritative Information (No Content)",
      headers: response.headers,
    });
    return noContentResponse;
  }
  return response;
}
